/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {ResourceSearchItem} from '../models/ResourceSearchItem';

export interface SearchProductResources$Request {
    resourceName: string;
    accountId?: number;
    userId?: number;
}

export interface SearchProductResources$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const searchProductResourcesRequest = createAction<PayloadData<void, SearchProductResources$Request>>('PRODUCT_ENTITLEMENTS_RESOURCE_SEARCH__SEARCH_PRODUCT_RESOURCES__REQUEST');
export const searchProductResourcesSuccess = createAction<PayloadData<Array<ResourceSearchItem>, SearchProductResources$Request>>('PRODUCT_ENTITLEMENTS_RESOURCE_SEARCH__SEARCH_PRODUCT_RESOURCES__SUCCESS');
export const searchProductResourcesFailure = createAction<PayloadData<Error, SearchProductResources$Request, true>>('PRODUCT_ENTITLEMENTS_RESOURCE_SEARCH__SEARCH_PRODUCT_RESOURCES__FAILURE');

export const searchProductResourcesActions = [
    searchProductResourcesRequest,
    searchProductResourcesSuccess,
    searchProductResourcesFailure
] as const;

/**
 * @param {string} meta.resourceName
 * @param {number} [meta.accountId]
 * @param {number} [meta.userId]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const searchProductResources = (meta: SearchProductResources$Request, config?: SearchProductResources$Config) => {
    const TRANSPORT_GET_PARAMS = {
        resourceName: meta.resourceName,
        accountId: meta.accountId,
        userId: meta.userId,
    };
    return {
        CALL_API: {
            types: searchProductResourcesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/product/entitlements/resources/search`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

